import { useSelector } from 'react-redux';

const useAssetsLayout = () => {
  const searchGridLayoutPreference = useSelector(
    (state) => state.searchPreferences.search_grid_layout
  );
  const assetType = useSelector(
    (state) => state.gallery.searchParameters.assettype
  );
  const layoutPreference =
    assetType === 'film'
      ? 'film_search_grid_layout'
      : 'image_search_grid_layout';
  const assetTypeLayoutPreference = useSelector(
    (state) => state.searchPreferences[layoutPreference]
  );

  return searchGridLayoutPreference || assetTypeLayoutPreference || 'mosaic';
};

export default useAssetsLayout;
